import { render, staticRenderFns } from "./ReceiverUploadLogin.vue?vue&type=template&id=d72600fc&"
import script from "./ReceiverUploadLogin.vue?vue&type=script&lang=js&"
export * from "./ReceiverUploadLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports